import React, { useState, useEffect, useRef } from 'react';

import Navigation from '../Navigation/Navigation';
import FilmScoreData from '../Data/FilmScoreData';
// import BrandsData from '../Data/BrandsData';
// import Brands from '../Landing/Brands';
import BrandsBanner from '../Tools/BrandsBanner';
// import MusicPlayer from '../Tools/MusicPlayer';
import ProjectModal from '../Tools/ProjectModal';
import ListItem from '../List/ListItem';
import BottomPlayBar from '../Tools/BottomPlayBar';

// import pause_circle from '../../Images/pause-circle.svg';
// import play_circle from '../../Images/play-circle.svg';
// import play_black from '../../Images/play_black.svg';
// import pause_black from '../../Images/pause_black.svg';
// import Cross from '../../Images/x.svg';
// import BANNER from '../../Images/banner1.jpg';
import profpic from '../../Images/Andy.jpeg';

import './FilmScoring.css';

// const profpic = 'https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
// const profpic = 'https://images.pexels.com/photos/1040880/pexels-photo-1040880.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';

const FilmScoring = ({navigate,dimensions,width}) => {
	// const [ hover, setHover ] = useState(true);
	// const [ count, setCount ] = useState(-1);
	// const [ carasel, setCarasel ] = useState(0);
	// const [ reloadHeader, setreloadHeader ] = useState(true);
	// const [ play, setPlay ] = useState(false);
	const [ modal, setModal ] = useState('');
	const [ playing, setPlaying ] = useState('');
	const [ selected, setSelected ] = useState('');
	const [ playBack, setPlayBack ] = useState(0);

	const audioRef = useRef();

	useEffect(()=>{window.scrollTo(0, 0);},[]);

	// useEffect(()=>{
	// 	// async function timeoutReturn() {
	// 	// 	return new Promise((resolve,reject)=>{
	// 	// 		setTimeout(()=>{
	// 	// 			resolve();
	// 	// 		},100);
	// 	// 	})
	// 	// }
	// 	// async function timedLoop() {
	// 	// 	let length_of_loop = Object.keys(FilmScoreData).length;
	// 	// 	let numb = 0;
	// 	// 	while(numb < length_of_loop){
	// 	// 		setCount(numb);
	// 	// 		await timeoutReturn();
	// 	// 		numb+=1;
	// 	// 	}
	// 	// }
	// 	// timedLoop();

	// 	setTimeout(()=>{
	// 		setreloadHeader(false);
	// 	},200);
	// },[]);

	const node = useRef();
	useEffect(()=>{
		function handleClick(e) {
			if(node.current) {
				if(node.current.contains(e.target)){
				} else {
					setModal('');
					// setPlaying('');
				}
			}
		}
		document.addEventListener('mousedown', handleClick, false);
		return () => {
			document.removeEventListener('mousedown', handleClick, false);
		}
	},[]);


	function playPressed(e,i) {
		const audio = document.getElementById(e);
		if(playing.id === e){
			if(playing.play === true){
				audio.pause();
				setPlaying({id:e,i:i,play:false});
			} else {
				audio.play();
				setPlaying({id:e,i:i,play:true});
			}
		} else {
			// stop previously playing song if playing
			if(playing.play === true){
				const audio_old = document.getElementById(playing.id);
				if(audio_old !== null) audio_old.pause();
			}
			audio.play();
			setPlaying({id:e,i:i,play:true});
		}
	}




	// const vidRef = useRef();

	// function caraselClicked(e) {
	// 	vidRef.current.pause();
	// 	setPlay(false);
	// 	// setreloadHeader(true);
	// 	// // setCarasel(e);
	// 	// setTimeout(()=>{
	// 	// 	setreloadHeader(false);
	// 	// },200);
	// }
	// function playClicked() {
	// 	if(play === true){
	// 		setPlay(false);
	// 		vidRef.current.pause();
	// 	} else {
	// 		setPlay(true);
	// 		vidRef.current.play();
	// 	}
	// }
	// function hoverEnter() {}
	// function hoverLeave() {}


	// function playPressed(e) {
	// 	const audio = document.getElementById(e);
	// 	if(playing.id === e){
	// 		if(playing.play === true){
	// 			audio.pause();
	// 			setPlaying({id:e,play:false});
	// 		} else {
	// 			audio.play();
	// 			setPlaying({id:e,play:true});
	// 		}
	// 	} else {
	// 		// stop previously playing song if playing
	// 		if(playing.play === true){
	// 			const audio_old = document.getElementById(playing.id);
	// 			audio_old.pause();
	// 		}
	// 		audio.play();
	// 		setPlaying({id:e,play:true});
	// 	}
	// }
	// function closeModal() {
	// 	setModal('');
	// 	setPlaying('');
	// }




	// function modalDisplay() {
	// 	if(modal !== ''){
	// 		const selected = FilmScoreData[modal];
	// 		let arr = [];
	// 		for(let i = 0; i < selected.songs.length; i++){
	// 			arr.push(
	// 				<div key={i}>
	// 					<MusicPlayer song={selected.songs[i]} id={modal+i} playPressed={playPressed} playing={playing} width={width} />
	// 				</div>
	// 			)
	// 		}
	// 		let meadiaLoop = [];
	// 		// 
	// 		for(let i = 0; i < selected.clips.length; i++){
	// 			meadiaLoop.push(
	// 				<div key={i}>
	// 					{i}
	// 					{/*<video loop={false} autoPlay={false} width={'100%'} controls={false}
	// 							ref={vidRef}>
	// 						<source src={selected.video} type="video/mp4" />
	// 					</video>*/}
	// 				</div>
	// 			)
	// 		}
	// 		return(
	// 			<div className='modalBack flexCenter'>
	// 				<div className='modal' ref={node}>
	// 					<div className='flexRight relative' style={{backgroundImage:'linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0))',height:50,marginBottom:-50,zIndex:200}}>
	// 						<img src={Cross} alt='cross' style={{height:24,margin:10}} className='pointer absolute' onClick={closeModal} />
	// 					</div>
	// 					<div className='flexCenter' style={{width:600,height:300,overflow:'hidden'}}>
	// 						<img src={selected.banner} alt='banner' style={{width:600}} />
	// 					</div>
	// 					<div style={{padding:10}}>
	// 						<div className='subHeading'>{selected.name}</div>
	// 						<div className='borderBottom' style={{marginTop:10}}></div>
	// 						{arr}
	// 					</div>
	// 				</div>
	// 			</div>
	// 		)
	// 	}
	// }
	function projectLoop() {
		let arr = [];
		for(let i = 0; i < FilmScoreData.length; i++){
			arr.push(
				<div key={i}>
					<ListItem item={FilmScoreData[i]} itt={i} width={width} selected={selected} setSelected={setSelected}
							dimensions={dimensions} playPressed={playPressed} playing={playing} setPlaying={setPlaying}
							playBack={playBack} setPlayBack={setPlayBack} audioRef={audioRef} />
				</div>
			)
		}
		return arr;
	}
	// function projectLoop2() {
	// 	let arr = [];
	// 	for(let i = 0; i < FilmScoreData.length; i++){
	// 		let className = 'pointer flexCenter invisible absolute';
	// 		if(count >= i){
	// 			className = 'pointer flexCenter riseUp absolute';
	// 		}
	// 		arr.push(
	// 			<div key={i} style={{height:200,width:134,overflow:'hidden',marginRight:20,marginTop:20}}
	// 					onClick={()=>{setModal(i);setPlaying('')}}>
	// 				<div className={className} style={{height:200,width:134,overflow:'hidden',}}>
	// 					<img src={FilmScoreData[i].thumbnail} alt='thumbnail' style={{height:200}} />
	// 				</div>
	// 			</div>
	// 		)
	// 	}
	// 	return <div className='flexHeightCenter' style={{flexWrap:'wrap'}}>{arr}</div>
	// }


	// function headerComponent() {
	// 	const video_options = [1,0,9,12,8,10,11,15];
	// 	const selected = FilmScoreData[video_options[carasel]];
	// 	let arr = [];
	// 	for(let i = 0; i < selected.brands.length; i++){
	// 		arr.push(
	// 			<div key={i} style={{marginLeft:20}}>
	// 				<img src={BrandsData[selected.brands[i]].img_light} alt='brand' style={{height:34}} />
	// 			</div>
	// 		)
	// 	}
	// 	let arr2 = [];
	// 	for(let i = 0; i < video_options.length; i++){
	// 		if(carasel === i){
	// 			arr2.push(
	// 				<div key={i} className='pointer' style={{height:11,width:11,borderRadius:12,background:'white',margin:5}}></div>
	// 			)
	// 		} else {
	// 			arr2.push(
	// 				<div key={i} className='pointer hoverOpacityUp' style={{height:9,width:9,borderRadius:12,background:'white',margin:5}}
	// 						onClick={()=>{caraselClicked(i)}}></div>
	// 			)
	// 		}
	// 	}
	// 	return(
	// 		<div onMouseEnter={hoverEnter} onMouseLeave={hoverLeave}>
	// 			{hover === true || play === false
	// 				? <div className='relative'>
	// 					<div className='absolute flexCenter fadeIn' style={{height:480,width:dimensions.width,zIndex:21,pointerEvents:'none'}}>
	// 						<div className='flexCenter' style={{marginBottom:30,pointerEvents:'auto'}}>
	// 							{play === true
	// 								? <img src={pause_circle} alt='pause-circle' style={{height:70}} className='pointer hoverOpacityUp' onClick={playClicked}/>
	// 								: <img src={play_circle} alt='pause-circle' style={{height:70}} className='pointer hoverOpacityUp' onClick={playClicked} />
	// 							}
	// 						</div>
	// 					</div>
	// 					<div className='absolute flexCenter flexHeightBottom fadeIn' style={{height:480,width:dimensions.width,zIndex:20}}>
	// 						<div className='subHeading flexCenter' style={{marginBottom:20}}>{arr2}</div>
	// 					</div>
	// 					<div style={{backgroundImage:'linear-gradient(to right, rgba(0,0,0,0),rgba(0,0,0,1))',
	// 							height:480,width:dimensions.width,zIndex:2,textShadow:'0px 0px 8px rgba(0,0,0,1)'}} className='absolute flexCenter fadeIn'>
	// 						<div style={{width:width,color:'white',textAlign:'right'}} className='flexRight '>
	// 							<div style={{width:420,marginRight:20}}>
	// 								<div className='heading bold'>{selected.name}</div>
	// 								<div className='subHeading' style={{marginTop:10}}>{selected.director}</div>
	// 								<div className='mainText' style={{marginTop:10}}>{selected.description}</div>
	// 								<div className='flexHeightCenter flexRight' style={{marginTop:30}}>{arr}</div>
	// 							</div>
	// 						</div>
	// 					</div>
	// 				</div>
	// 				: null
	// 			}
	// 			{reloadHeader === true
	// 				? <div style={{background:'black',height:480,width:dimensions.width}}></div>
	// 				: <div className='flexCenter' style={{width:'100%',height:480,overflow:'hidden',
	// 					backgroundImage:'linear-gradient(to right, rgb(54,70,99), black)'}}>
	// 					<video loop={false} autoPlay={false} width={'100%'} controls={false}
	// 							ref={vidRef}>
	// 						<source src={selected.video} type="video/mp4" />
	// 					</video>
	// 				</div>
	// 			}
	// 		</div>
	// 	)
	// }

	let className = 'flexHeightCenter';
	let textWide = width-150;
	if(dimensions.width < 700){
		className = '';
		textWide = width;
	}
	let mini_high = 40;
	if(dimensions.width < 800) mini_high = 40;
	if(dimensions.width < 600) mini_high = 20;
	return(
		<div>
			<Navigation navigate={navigate} width={width} />
			{/*{projectLoop()}*/}
			{dimensions.width < 700
				? null
				: <div style={{height:60}}></div>
			}

			{/*<div style={{width:'100%',height:240,overflow:'hidden',color:'white',textShadow:'0px 0px 8px rgba(0,0,0,1)',zIndex:2,
					backgroundImage:'linear-gradient(to right,rgba(0,0,0,0.7),rgba(0,0,0,0))'}} className='flexCenter absolute'>
				<div className={className}>
					<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30,boxShadow:'0px 0px 8px rgba(0,0,0,1)'}} className='flexCenter'>
						<img src={profpic} alt='profpic' style={{width:'100%'}} />
					</div>
					<div style={{width:textWide}}>
						<div className='heading bold' style={{marginBottom:10}}>Film scoring</div>
						<div className='subHeading fadeIn'>Composer of music for film and TV</div>
					</div>
				</div>
			</div>*/}

			{/*<div style={{width:'100%',height:240,overflow:'hidden',background:'black'}} className='flexCenter'>
				<img src={BANNER} alt='BANNER' style={{width:'120%'}} />
			</div>*/}
			{dimensions.width < 700
				? <div className='riseUpC'>
					<div style={{width:width,margin:'auto',zIndex:200,pointerEvents:'none'}} className=' relative'>
						<div style={{height:20}}></div>
						<div className={className}>
							<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30,pointerEvents:'auto'}}
									className='flexCenter' onClick={()=>{navigate('/')}}>
								<img src={profpic} alt='profpic' style={{width:'100%'}} />
							</div>
							<div style={{width:textWide}}>
								
							</div>
						</div>
						{/*<div style={{height:mini_high}}></div>*/}
					</div>
					<div style={{width:width,margin:'auto',marginTop:-120}} className=''>
						{/*<div style={{height:20}}></div>*/}
						<div className={className}>
							<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'
									onClick={()=>{navigate('/')}}>
								{/*<img src={profpic} alt='profpic' style={{width:'100%'}} />*/}
							</div>
							<div style={{width:textWide}}>
								<div className='heroText bold' style={{marginBottom:10}} onClick={()=>{navigate('/')}}>Film scoring</div>
								<div className='heading bold'>Composer of music for film and TV</div>
							</div>
						</div>
						<div style={{height:mini_high}}></div>
					</div>
				</div>
				: <div style={{width:width,margin:'auto'}} className='riseUp'>
					<div style={{height:20}}></div>
					<div className={className}>
						<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'
								onClick={()=>{navigate('/')}}>
							<img src={profpic} alt='profpic' style={{width:'100%'}} />
						</div>
						<div style={{width:textWide}}>
							<div className='heroText bold' style={{marginBottom:10}} onClick={()=>{navigate('/')}}>Film scoring</div>
							<div className='heading bold'>Composer of music for film and TV</div>
						</div>
					</div>
					<div style={{height:mini_high}}></div>
				</div>
			}
					
			<BrandsBanner dimensions={dimensions} />
			<div style={{height:mini_high}}></div>
			
			<div style={{width:width,margin:'auto'}} className='riseUp'>
				{/*<div style={{height:20}}></div>*/}
				{/*<div style={{width:'100%',overflow:'hidden',color:'white',textShadow:'0px 0px 8px rgba(0,0,0,1)',zIndex:2,
						// backgroundImage:'linear-gradient(to right,rgba(0,0,0,0.7),rgba(0,0,0,0))'
						}} className='flexCenter'>
					<div className={className}>
						<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30,boxShadow:'0px 0px 8px rgba(0,0,0,1)'}} className='flexCenter'>
							<img src={profpic} alt='profpic' style={{width:'100%'}} />
						</div>
						<div style={{width:textWide}}>
							<div className='heading bold' style={{marginBottom:10}}>Film scoring</div>
							<div className='subHeading fadeIn'>Composer of music for film and TV</div>
						</div>
					</div>
				</div>*/}
				{/*<div className='heading bold' style={{marginBottom:10}}>Catalog</div>*/}
				{/*<div className='subHeading'>Andy's music has been used by a variety of Films and TV shows, broadcast globally</div>*/}
				{/*<div className={className}>
					<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'>
						<img src={profpic} alt='profpic' style={{width:'100%'}} />
					</div>
					<div style={{width:textWide}}>
						<div className='heading bold' style={{marginBottom:10}}>Film scoring</div>
						<div className='subHeading fadeIn'>Composer of music for film and TV</div>
					</div>
				</div>*/}
				{/*<Brands />*/}
				{/*<div className='subHeading fadeIn'>Film scoring</div>
				<div style={{height:10}}></div>
				<div className='mainText fadeIn'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</div>
				<div style={{height:30}}></div>*/}
				<div style={{height:mini_high}}></div>
				{projectLoop()}
				{/*{projectLoop2()}*/}
				<div style={{height:80}}></div>
				<div style={{height:30}}></div>
				
			</div>

			<div style={{height:80}}></div>

			{/*{modalDisplay()}*/}
			<ProjectModal modal={modal} setModal={setModal} />

			<BottomPlayBar width={width} playing={playing} playPressed={playPressed} route={'/film'}
					audioRef={audioRef} playBack={playBack} dimensions={dimensions} />
		</div>
	)
}

export default FilmScoring;